import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createUser } from '../../actions/users'
import { useNavigate } from 'react-router-dom';

const Form = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user);
  const [formData, setFormData] = useState({
    email: "",
    password: ""
  });

  const handleSubmit = (event) => {
    event.preventDefault();
    dispatch(createUser(formData));
    navigate("/");
  }

  return (
    <div>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor='email'>Email</label>
          <input name="email" onChange={(e) => setFormData({ ...formData, email: e.target.value })} value={formData.name} className="form-control center" id="email" aria-describedby="body" type="email" />
          <label htmlFor='password'>Password</label>
          <input name='password' onChange={(e) => setFormData({ ...formData, password: e.target.value })} value={formData.name} className="form-control center" id="password" aria-describedby="body" type="password" />
        </div>
        <button type="submit" className="btn btn-primary">Create User</button>
      </form>
    </div>
  )
}

export default Form;